import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

/**
 * Redux state interface for NBBV Action Report.
 *
 * @interface NbbvARState
 * @property {string[]} availableKpis - List of available KPIs for the report
 * @property {string[]} affAbosToExpand - List of AFF-ABO identifiers to expand in tree view
 */
interface NbbvARState {
  availableKpis: string[];
  affAbosToExpand: string[];
}

export const initialState: NbbvARState = {
  availableKpis: [],
  affAbosToExpand: [],
};

const { actions, reducer } = createSlice({
  name: "nbbvActionReport",
  initialState,
  reducers: {
    setAvailableKpis: (state, action: PayloadAction<string[]>) => {
      state.availableKpis = action.payload;
    },
    setAffAbosToExpand: (state, action: PayloadAction<string[]>) => {
      state.affAbosToExpand = action.payload;
    },
  },
});

export const { setAvailableKpis, setAffAbosToExpand } = actions;

export default reducer;
